import { Separator } from '@ais-ui/ui-core';
import { TargetForm } from './TargetForm';
import { useLocalization } from '@ais-ui/locale-management';
import { TargetScaleForm } from './ScaleForm';

export function SettingsTargetPage() {
  const { messages } = useLocalization();
  return (
    <div className="space-y-6 w-full">
      <div>
        <h3 className="text-2xl font-medium">{messages.settingsTargetTitle}</h3>
        <p className="text-sm text-muted-foreground">
          {messages.settingsTargetSubtitle}
        </p>
      </div>
      <Separator className="w-full" />
      <TargetScaleForm></TargetScaleForm>
      <TargetForm />
    </div>
  );
}
